import React from 'react';
function HeartCrack({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 41 40"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <g>
        <path
          d="M32.1666 23.3333C34.6499 20.9 37.1666 17.9833 37.1666 14.1667C37.1666 11.7355 36.2008 9.40394 34.4817 7.68485C32.7626 5.96577 30.4311 5 27.9999 5C25.0666 5 22.9999 5.83333 20.4999 8.33333C17.9999 5.83333 15.9333 5 12.9999 5C10.5688 5 8.23719 5.96577 6.51811 7.68485C4.79902 9.40394 3.83325 11.7355 3.83325 14.1667C3.83325 18 6.33325 20.9167 8.83325 23.3333L20.4999 35L32.1666 23.3333Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.5001 21.6667L18.8334 20L22.1667 16.6667L17.1667 11.6667L20.5001 8.33334"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

export default HeartCrack;
